module.exports = __webpack_public_path__ + "static/media/action-flow.087ec256.svg";